import {HashLink} from 'react-router-hash-link'

import {APP_ROUTES} from '../../routes/routes'

const FooterAboutLinks = () => {
  const aboutLinks = [
    {id: 'about-markets', label: 'Markets'},
    {id: 'about-values', label: 'Core values'},
    {id: 'about-team', label: 'Leadership team'}
  ]

  const links = aboutLinks.map(({id, label}) => {
    return (
      <li className="footer-link" key={`footer-about-links-${id}`}>
        <HashLink to={`${APP_ROUTES.ABOUT}#${id}`}>
          {label}
        </HashLink>
      </li>
    )
  })

  return (
    <ul>
      <li className="footer-link heading">About Us</li>
      {links}
    </ul>
  )
}

export default FooterAboutLinks
